class MSClient {
  static fetch({ method = "GET", params = {}, url } = {}) {
    const _url = "/apps/ms/showrooms" + (url ? url : "");

    console.log(_url);

    return fetch(_url, {
      method: method || "GET",
      headers: {
        Authentication: customer.id,
        "Content-Type": "application/json"
      },
      body: method === "GET" ? undefined : JSON.stringify(params)
    }).then(res => res.json());
  }

  static fetchProductJson(handle) {
    return fetch(`/products/${handle}.json`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(res => res.json());
  }

  static post(params) {
    return this.fetch({ method: "POST", params });
  }

  static put(url, params) {
    return this.fetch({ method: "PUT", params, url });
  }

  static delete(url, params) {
    return this.fetch({ method: "DELETE", params, url });
  }
}
